import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { Card, Header1, Header2 } from '@/shared/theme/styled-components'

import DeleteModal from './DeleteModal/DeleteModal'
import LocationModal from './LocationModal/LocationModal'
import LocationsTable from './LocationsTable/LocationsTable'
import useItalyFiscalCodesManagement from './useItalyFiscalCodesManagement'
import { PaginationRow, SearchField, Toolbar } from './styled-components'

const ItalyFiscalCodesManagement = () => {
  const {
    title,
    resultsCount,
    tableOptions,
    table,
    searchInput,
    searchLabel,
    addLabel,
    loadingText,
    previousLabel,
    nextLabel,
    error,
    isErrorHidden,
    isLoaderHidden,
    isTableHidden,
    pageLabel,
    isPreviousDisabled,
    isNextDisabled,
    onTableChange,
    onSearchChange,
    onAdd,
    onPreviousPage,
    onNextPage,
  } = useItalyFiscalCodesManagement()

  return (
    <Card>
      <Header1 id='italy-fiscal-codes-title'>{title}</Header1>
      <Header2>{resultsCount}</Header2>

      <Toolbar>
        {/* @ts-expect-error SDButtonGroup is a JS component */}
        <SDButtonGroup options={tableOptions} selectedValue={table} stretch={false} onClickHandler={onTableChange} />
        <SearchField>
          {/* @ts-expect-error SDInput is a JS component */}
          <SDInput
            id='italy-fiscal-codes-search'
            label={searchLabel}
            currentValue={searchInput}
            outerOnchange={onSearchChange}
          />
        </SearchField>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton id='italy-fiscal-codes-add-btn' block={false} onClick={onAdd}>
          {addLabel}
        </SDButton>
      </Toolbar>

      <SDNotification type='negative' hidden={isErrorHidden} primaryText={error} />
      <SDLoader hidden={isLoaderHidden} text={loadingText} />
      <LocationsTable hidden={isTableHidden} />

      <PaginationRow>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton block={false} disabled={isPreviousDisabled} onClick={onPreviousPage}>
          {previousLabel}
        </SDButton>
        <span>{pageLabel}</span>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton block={false} disabled={isNextDisabled} onClick={onNextPage}>
          {nextLabel}
        </SDButton>
      </PaginationRow>

      <LocationModal />
      <DeleteModal />
    </Card>
  )
}

export default ItalyFiscalCodesManagement
